import './main.scss';
import Dashboard from '../../pages/dashboard/dashboard';
import tournaments from '../../assets/tournaments.json';
import teams from '../../assets/teams.json';

const Main = (props) => {
    const tournament = tournaments.Tournaments.find((item) => item.Active === 1);


    return [
        <main className='container-md mt-3'>
            <h1 className='visually-hidden-focusable'></h1>
            <Dashboard tournament={ tournament } teamsData={ teams }></Dashboard>
        </main>
    ];
};

export default Main;